import { render, staticRenderFns } from "./best-available-grid.component.vue?vue&type=template&id=8cffe5d8&scoped=true"
import script from "./best-available-grid.component.vue?vue&type=script&lang=js"
export * from "./best-available-grid.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cffe5d8",
  null
  
)

export default component.exports